import React, { useRef, useState, useEffect } from "react";
import { Loader, Dimmer } from "semantic-ui-react";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import axios from "axios";
import { validaSoloNumero, validaEmail } from "../../util/varios";
import { Mensaje, MensajeSiNo } from "../mensajes";
import CatalogoPersonaAthos from "../../catalogos/catalogoPersonaAthos";

export const ActualizarAfiliados = (props) => {
  moment.locale("es-us");

  let op = require("../../../public/modulos/datos");
  let token = sessionStorage.getItem("jwtToken");
  const fechaSistema = JSON.parse(sessionStorage.getItem("fechasistema"));
  var fecha = moment(fechaSistema).subtract(18, "year").calendar();

  const btnAcepta = useRef();
  const btnCancela = useRef();
  const cmbStatus = useRef();
  const txtIdOrg = useRef();
  const txtNomOrg = useRef();
  const cmbRif = useRef();
  const txtRif = useRef();
  const txtDomicilio = useRef();
  const cmbEstado = useRef();
  const cmbMunicipio = useRef();
  const cmbCiudad = useRef();
  const cmbBaseDatos = useRef();
  const txtEmailOrg = useRef();
  const txtTlfOrg = useRef();
  const txtCelOrg = useRef();
  const txtFaxOrg = useRef();
  const txtCedula = useRef();
  const txtNombreRespon = useRef();
  const txtApellidoRespon = useRef();
  const txtDireccionRespon = useRef();
  const txtEmailRespon = useRef();
  const txtTlfRespon = useRef();
  const txtCelRespon = useRef();
  const txtFechaNac = useRef();
  const cmbNacionalidad = useRef();
  const cmbSexo = useRef();
  const txtItemsfactu = useRef();

  const [activate, setActivate] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [habilitadoNU, setHabilitadoNU] = useState(false);
  const [ciudad, setCiudad] = useState();
  const [municipio, setMunicipio] = useState();
  const [estado, setEstado] = useState();
  const [baseDatos, setBaseDatos] = useState([]);
  const [body, setBody] = useState(null);
  const [mostrar3, setMostrar3] = useState(false);
  const [operacion, setOperacion] = useState(0);
  const [operacionPer, setOperacionPer] = useState(0);
  const [tecla, setTecla] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [imagen, setImagen] = useState({
    imagen: "subir.png",
    imagenactual: "subir.png",
  });
  const [ticket, setTicket] = useState({
    ticketnuevo: "athos.jpg",
    ticketactual: "athos.jpg",
  });
  const [pathImage, setPathImage] = useState({
    imagen: `${op.conexion}/imagen?img=subir.png`,
  });

  const [pathTicket, setPathTicket] = useState({
    ticket: `${op.conexion}/imagen?img=athos.jpg`,
  });

  /* bloquear tab */
  const [tabIndex, setTabIndex] = useState({
    tab1: "tab",
    tab2: "",
  });
  /* activar tab */
  const [activeTab, setACtiveTab] = useState({
    tab1: "nav-link active",
    tab2: "nav-link",
  });
  /* mostar tabPanel */
  const [tabPanel, setTabPanel] = useState({
    tab1: "tab-pane fade show active",
    tab2: "tab-pane fade",
  });
  /* validar tab */
  const [tabvalid, setTabValid] = useState({
    tab1: "true",
    tab2: "false",
  });

  const CatalogoEstado = () => {
    let campos = "*";
    let nomtab = "estado";
    let orden = "idestado";
    let endpoint = `${op.conexion}/api/athos/consulta/seleccionarregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setEstado(response.data);
          setActivate(false);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarBasedeDatos = () => {
    let campos = "*";
    let nomtab = "basedatos";
    let orden = "idbasedatos";
    let endpoint = `${op.conexion}/api/athos/consulta/seleccionarregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setBaseDatos(response.data);
          setActivate(false);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarCiudad = (id, idciu) => {
    let campos = "*";
    let nomtab = "ciudad";
    let nomid = "idmunicipio";
    let endpoint = `${op.conexion}/api/athos/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setCiudad(response.data);
            cmbCiudad.current.value = idciu;
            seleccionarMunicipio(cmbEstado.current.value, id);
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarMunicipio = (id, idmun) => {
    setActivate(true);
    let campos = "*";
    let nomtab = "municipio";
    let nomid = "idestado";

    let endpoint = `${op.conexion}/api/athos/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setMunicipio(response.data);
            cmbMunicipio.current.value = idmun;
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarCiudadCampos = (data, dataper) => {
    let campos = "*";
    let nomtab = "ciudad";
    let nomid = "idmunicipio";
    let endpoint = `${op.conexion
      }/api/athos/consulta/modelirows?campos=${campos}&id=${data.municipio.trim()}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setCiudad(response.data);
            llenarCampos(data, dataper);
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarMunicipioCampos = (data, dataper) => {
    let campos = "*";
    let nomtab = "municipio";
    let nomid = "idestado";

    let endpoint = `${op.conexion
      }/api/athos/consulta/modelirows?campos=${campos}&id=${data.estado.trim()}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setMunicipio(response.data);
            seleccionarCiudadCampos(data, dataper);
          }
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const datosPersona = (data) => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";

    let endpoint = `${op.conexion}/api/athos/consulta/modeli?campos=${campos}&id=${data.responsable}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          seleccionarMunicipioCampos(data, response);
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarOrganizacion = (id) => {
    setActivate(true);
    let campos = "*";
    let nomtab = "organizacion";
    let nomid = "idorganizacion";
    let endpoint = `${op.conexion}/api/athos/consulta/modeli?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          datosPersona(response.data);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleUpload = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      const name = e.target;

      if (file.type.includes("image")) {
        const reader = new FileReader();
        reader.readAsDataURL(file);

        if (name.name === "imagen") {
          reader.onload = function load() {
            setPathImage({ ...pathImage, imagen: reader.result });
          };
        }

        if (name.name === "ticket") {
          reader.onload = function load() {
            setPathTicket({ ...pathTicket, ticket: reader.result });
          };
        }
      }

      if (name.name === "imagen") {
        setImagen({ ...imagen, [e.target.name]: e.target.files[0] });
      }

      if (name.name === "ticket") {
        setTicket({ ...ticket, ticketnuevo: e.target.files[0] });
      }
    }
  };

  const cancelar = () => {
    setTabIndex({ tab1: "tab", tab2: "" });
    props.onHideCancela();
    blanquear();
  };

  const blanquear = () => {
    txtIdOrg.current.value = "";
    txtNomOrg.current.value = "";
    txtDomicilio.current.value = "";
    cmbRif.current.value = "";
    txtRif.current.value = "";
    txtEmailOrg.current.value = "";
    txtTlfOrg.current.value = "";
    txtCelOrg.current.value = "";
    cmbCiudad.current.value = "";
    cmbMunicipio.current.value = "";
    cmbEstado.current.value = "";
    cmbBaseDatos.current.value = "";
    cmbStatus.current.value = "";
    txtItemsfactu.current.value = "";

    txtCedula.current.value = "";
    txtNombreRespon.current.value = "";
    txtApellidoRespon.current.value = "";
    txtDireccionRespon.current.value = "";
    txtEmailRespon.current.value = "";
    txtTlfRespon.current.value = "";
    txtCelRespon.current.value = "";
    txtFechaNac.current.value = "";
    cmbNacionalidad.current.value = "";
    cmbSexo.current.value = "";

    setMunicipio();
    setCiudad();
    setDeshabilitado(true);
    setImagen({ imagen: "subir.png", imagenactual: "subir.png" });
    setPathImage({ imagen: op.conexion + "/imagen?img=subir.png" });

    setTicket({ ticketnuevo: "subir.png", ticketactual: "athos.jpg" });
    setPathTicket({ ticket: op.conexion + "/imagen?img=athos.jpg" });
  };

  const onChange = (event) => {
    if (event.target.name === "idestado") {
      cmbEstado.current.value = event.target.value;
      setMunicipio();
      setCiudad();

      if (event.target.value !== "") {
        seleccionarMunicipio(event.target.value, "");
      }
    } else if (event.target.name === "idmunicipio") {
      cmbMunicipio.current.value = event.target.value;
      setCiudad();

      if (event.target.value !== "") {
        seleccionarCiudad(event.target.value, "");
      }
    } else if (event.target.name === "idciudad") {
      cmbCiudad.current.value = event.target.value;
    } else if (
      event.target.name === "riforg" ||
      event.target.name === "telefonoorg" ||
      event.target.name === "celularorg" ||
      event.target.name === "items"
    ) {
      validaSoloNumero(event);
    } /*  else if(event.target.name === 'inputRif'){
            validarRif()
        } */
  };

  const handleCloseCatalogoPer = () => {
    setMostrar3(false);
  };

  const handleAceptaCatalogoPer = (values) => {
    setMostrar3(false);
    txtCedula.current.value = values.cedPer;
    txtNombreRespon.current.value = values.nomPer;
    txtApellidoRespon.current.value = values.apePer;
    txtDireccionRespon.current.value = values.direPer;
    txtEmailRespon.current.value = values.correoPer;
    txtTlfRespon.current.value = values.tlf1Per;
    txtCelRespon.current.value = values.tlf2Per;
    txtFechaNac.current.value = moment(values.fnacPer).format("YYYY-MM-DD");
    cmbNacionalidad.current.value = values.nacPer;
    cmbSexo.current.value = values.sexoPer;
  };

  const validarPersona = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setTecla(event.which);
        datosRes(event.target.value);
      } else {
        txtNombreRespon.current.value = "";
      }
    }
  };

  const datosRes = (cedula) => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";

    let endpoint = `${op.conexion}/api/athos/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setHabilitadoNU(true);
          txtNombreRespon.current.value = "";
          txtApellidoRespon.current.value = "";
          txtDireccionRespon.current.value = "";
          txtEmailRespon.current.value = "";
          txtTlfRespon.current.value = "";
          txtCelRespon.current.value = "";
          txtFechaNac.current.value = "";
          cmbNacionalidad.current.value = "V";
          cmbSexo.current.value = "M";
          if (response.data !== "") {
            setHabilitadoNU(false);
            setOperacionPer(0);
            txtNombreRespon.current.value = response.data.nombres;
            txtApellidoRespon.current.value = response.data.apellidos;
            txtDireccionRespon.current.value = response.data.direccion;
            txtEmailRespon.current.value = response.data.correoe;
            txtTlfRespon.current.value = response.data.tlf1;
            txtCelRespon.current.value = response.data.tlf2;
            txtFechaNac.current.value = moment(
              response.data.fnacimiento
            ).format("YYYY-MM-DD");
            cmbNacionalidad.current.value = response.data.nacionalidad;
            cmbSexo.current.value = response.data.sexo;
            if (tecla === 13) {
              btnAcepta.current.focus();
            }
          } else {
            setOperacionPer(1);
            setHabilitadoNU(true);
            if (tecla === 13) {
              setTimeout(() => {
                txtNombreRespon.current.focus();
              }, 100);
            }
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const handleInputChange = (event) => {
    if (event.which === 13) {
      var valido;
      if (event.target.id === "inputRazonSoc") {
        txtNomOrg.current.focus();
      } else if (event.target.id === "inputNombre") {
        cmbRif.current.focus();
      } else if (event.target.id === "inputRif") {
        txtDomicilio.current.focus();
      } else if (event.target.id === "inputDomicilio") {
        cmbEstado.current.focus();
      } else if (event.target.id === "inputEmailOrg") {
        txtTlfOrg.current.focus();
      } else if (event.target.id === "inputTlfOrg") {
        txtCelOrg.current.focus();
      } else if (event.target.id === "inputNombreRespon") {
        txtApellidoRespon.current.focus();
      } else if (event.target.id === "inputApellidoRespon") {
        txtDireccionRespon.current.focus();
      } else if (event.target.id === "inputEmailRespon") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtTlfRespon.current.focus();
        } else {
          if (event.target.value !== "") {
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto: "Formato de Email invalido.",
              icono: "informacion",
            });
            event.target.value = "";
          } else {
            txtTlfRespon.current.focus();
          }
        }
      } else if (event.target.id === "inputTlfRespon") {
        txtCelRespon.current.focus();
      } else if (event.target.id === "inputCelRespon") {
        txtFechaNac.current.focus();
      } else if (event.target.id === "inputFechaNac") {
        cmbNacionalidad.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.id === "inputEmailOrg") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtTlfOrg.current.focus();
        } else {
          if (event.target.value !== "") {
            event.target.value = "";
          } else {
            txtTlfOrg.current.focus();
          }
        }
      } else if (event.target.id === "inputTlfOrg") {
        txtCelOrg.current.focus();
      } else if (event.target.id === "inputCelOrg") {
        txtFaxOrg.current.focus();
      } else if (event.target.id === "inputEmailRespon") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtTlfRespon.current.focus();
        } else {
          if (event.target.value !== "") {
            event.target.value = "";
          } else {
            txtTlfRespon.current.focus();
          }
        }
      } else if (event.target.id === "inputTlfRespon") {
        txtCelRespon.current.focus();
      } else if (event.target.id === "inputCelRespon") {
        txtFechaNac.current.focus();
      } else {
        return false;
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    var mensaje = "";
    if (txtNomOrg.current.value.trim() === "") {
      mensaje = "El Nombre de la Organizacion no debe estar vacio";
      sigue = false;
      setTabIndex(0);
      txtNomOrg.current.focus();
    } else if (txtRif.current.value.trim() === "") {
      mensaje = "El Rif de la Organizacion no debe estar vacio";
      sigue = false;
      setTabIndex(0);
      txtRif.current.focus();
    } else if (txtDomicilio.current.value.trim() === "") {
      mensaje = "El Domicilio de la Organizacion no debe estar vacio";
      sigue = false;
      setTabIndex(0);
      txtDomicilio.current.focus();
    } else if (cmbEstado.current.value.trim() === "") {
      mensaje = "Por Favor Seleccione el Estado";
      sigue = false;
      setTabIndex(0);
      cmbEstado.current.focus();
    } else if (cmbMunicipio.current.value.trim() === "") {
      mensaje = "Por Favor Seleccione el Municipio";
      sigue = false;
      setTabIndex(0);
      cmbMunicipio.current.focus();
    } else if (cmbCiudad.current.value.trim() === "") {
      mensaje = "Por Favor Seleccione la Ciudad";
      sigue = false;
      setTabIndex(0);
      cmbCiudad.current.focus();
    } else if (cmbBaseDatos.current.value.trim() === "") {
      mensaje = "Por Favor Seleccione la base de Datos";
      sigue = false;
      setTabIndex(0);
      cmbBaseDatos.current.focus();
    } else if (cmbStatus.current.value.trim() === "") {
      mensaje = "Por Favor Seleccione el Estatus";
      sigue = false;
      setTabIndex(0);
      cmbStatus.current.focus();
    } else if (txtCedula.current.value.trim() === "") {
      mensaje = "La cedula no debe estar vacia";
      sigue = false;
      setTabIndex({ tab1: "tab", ...tabIndex });
      txtCedula.current.focus();
    } else if (txtNombreRespon.current.value.trim() === "") {
      mensaje = "Los nombres no deben estar vacios";
      sigue = false;
      setTabIndex({ tab1: "", tab2: "tab" });
      setTabIndex({ tab1: "tab", ...tabIndex });
      setACtiveTab({ tab1: "nav-link", tab2: "nav-link active" });
      setTabValid({ tab1: "false", tab2: "true" });
      setTabPanel({ tab1: "tab-pane fade", tab2: "tab-pane fade show active" });
      txtNombreRespon.current.focus();
    } else if (txtApellidoRespon.current.value.trim() === "") {
      mensaje = "Los Apellidos no deben estar vacio";
      sigue = false;
      setTabIndex({ tab1: "", tab2: "tab" });
      setTabIndex({ tab1: "tab", ...tabIndex });
      setACtiveTab({ tab1: "nav-link", tab2: "nav-link active" });
      setTabValid({ tab1: "false", tab2: "true" });
      setTabPanel({ tab1: "tab-pane fade", tab2: "tab-pane fade show active" });

      setTabIndex(1);
      txtApellidoRespon.current.focus();
    } else if (txtDireccionRespon.current.value.trim() === "") {
      mensaje = "La direccion del Responsable no debe estar vacia";
      sigue = false;
      setTabIndex({ tab1: "", tab2: "tab" });
      setTabIndex({ tab1: "tab", ...tabIndex });
      setACtiveTab({ tab1: "nav-link", tab2: "nav-link active" });
      setTabValid({ tab1: "false", tab2: "true" });
      setTabPanel({ tab1: "tab-pane fade", tab2: "tab-pane fade show active" });

      setTabIndex(1);
      txtDireccionRespon.current.focus();
    } else if (txtFechaNac.current.value.trim() === "") {
      mensaje = "La fecha de nacimiento no debe estar vacia";
      sigue = false;
      setTabIndex({ tab1: "", tab2: "tab" });
      setTabIndex({ tab1: "tab", ...tabIndex });
      setACtiveTab({ tab1: "nav-link", tab2: "nav-link active" });
      setTabValid({ tab1: "false", tab2: "true" });
      setTabPanel({ tab1: "tab-pane fade", tab2: "tab-pane fade show active" });

      setTabIndex(1);
      txtFechaNac.current.focus();
    }

    if (sigue) {
      var org = [];
      var datoPer = [];

      org.push({
        idorganizacion:
          txtIdOrg.current.value === "" ? 0 : txtIdOrg.current.value,
        estado: cmbEstado.current.value,
        municipio: cmbMunicipio.current.value,
        ciudad: cmbCiudad.current.value,
        nombre: txtNomOrg.current.value,
        direccion: txtDomicilio.current.value,
        tlf1: txtTlfOrg.current.value,
        tlf2: txtCelOrg.current.value,
        correoe: txtEmailOrg.current.value,
        rif: cmbRif.current.value + txtRif.current.value,
        responsable: txtCedula.current.value,
        idbasedatos: cmbBaseDatos.current.value,
        statusorg: cmbStatus.current.value,
        c_items: parseInt(txtItemsfactu.current.value),
      });
      datoPer.push({
        apellidos: txtApellidoRespon.current.value.trim(),
        cedula: txtCedula.current.value,
        correoe: txtEmailRespon.current.value,
        direccion: txtDireccionRespon.current.value.trim(),
        fnacimiento: txtFechaNac.current.value,
        nacionalidad: cmbNacionalidad.current.value,
        nombres: txtNombreRespon.current.value.trim(),
        sexo: cmbSexo.current.value,
        tlf1: txtTlfRespon.current.value,
        tlf2: txtCelRespon.current.value,
      });

      let upload = new FormData();

      upload.append("operacionper", operacionPer);
      upload.append("org", JSON.stringify(org));
      upload.append("perso", JSON.stringify(datoPer));
      upload.append(
        "organizacion",
        cmbRif.current.value + txtRif.current.value
      );
      upload.append("imagenactual", imagen.imagenactual);
      upload.append("imagennueva", imagen.imagen);

      upload.append("ticketactual", ticket.ticketactual);
      upload.append("ticketnuevo", ticket.ticketnuevo);

      setBody(upload);

      let msg = "";
      if (props.operacion === 1) {
        msg = "Esta Seguro de Registrar estos Datos.";
      } else if (props.operacion === 2) {
        msg = "Esta Seguro de Modificar estos Datos.";
      } else if (props.operacion === 3) {
        msg = "Esta Seguro de Eliminar estos Datos.";
      }

      setMensajesino({
        mostrar: true,
        titulo: "Confirmación.",
        texto: msg,
        icono: "confirmacion",
      });
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: mensaje,
        icono: "informacion",
      });
      setTimeout(() => {
        txtNombreRespon.current.focus();
      }, 500);
    }
  };

  const procesarAfiliado = () => {
    setActivate(true);

    let endpoint = `${op.conexion}/api/athos/organizacion/actualizarorganizacion/${props.operacion}`;

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (props.operacion === 1) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro creado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 2) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro modificado correctamente",
              icono: "exito",
            });
          } else if (props.operacion === 3) {
            setMensaje({
              mostrar: true,
              titulo: "Exito.",
              texto: "registro eliminado correctamente",
              icono: "exito",
            });
          }
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      })
      .finally(function () {
        setActivate(false);
      });
  };

  const tabs = (vl) => (e) => {
    e.preventDefault();

    if (vl === 2) {
      setACtiveTab({ tab1: "nav-link", tab2: "nav-link active" });
      setTabValid({ tab1: "false", tab2: "true" });
      setTabPanel({ tab1: "tab-pane fade", tab2: "tab-pane fade show active" });
    } else {
      setACtiveTab({ tab1: "nav-link active", tab2: "nav-link " });
      setTabValid({ tab1: "true", tab2: "false" });
      setTabPanel({
        tab1: "tab-pane fade show active",
        tab2: "tab-pane fade ",
      });
    }
  };

  const handleCloseSi = () => {
    setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" });
    procesarAfiliado();
  };

  const cerrarModal = () => {
    setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
    props.onHideAcepta();
    cancelar();
  };

  const llenarCampos = (data, dataper) => {
    if (
      data.logo.trim() !== "subir.png" &&
      data.logo.trim() !== null &&
      data.logo.trim() !== ""
    ) {
      setImagen({ ...imagen, imagenactual: data.logo.trim() });
      setPathImage({
        imagen:
          op.conexion + "/imagen?img=athos/organizacion/" + data.logo.trim(),
      });
    }

    if (
      data.ticket.trim() !== "athos.jpg" &&
      data.ticket.trim() !== null &&
      data.ticket.trim() !== ""
    ) {
      setTicket({ ...ticket, ticketactual: data.ticket.trim() });
      setPathTicket({
        ticket:
          op.conexion + "/imagen?img=athos/organizacion/" + data.ticket.trim(),
      });
    }

    if (props.operacion === 4 || props.operacion === 3) {
      setDeshabilitado(true);
    } else {
      setDeshabilitado(false);
    }
    setHabilitadoNU(false);
    txtIdOrg.current.value = data.idorganizacion;
    txtItemsfactu.current.value = data.c_items;
    txtNomOrg.current.value = data.nombre.trim();
    txtDomicilio.current.value = data.direccion.trim();
    cmbRif.current.value = isNaN(data.rif.substring(0, 1))
      ? data.rif.substring(0, 1)
      : "";
    txtRif.current.value = isNaN(data.rif.substring(0, 1))
      ? data.rif.substring(1, data.rif.trim().length)
      : !isNaN(data.rif.substring(0, 1))
        ? data.rif.substring(0, data.rif.trim().length)
        : "";
    txtEmailOrg.current.value =
      data.correoe === null ? data.correoe : data.correoe.trim();
    txtTlfOrg.current.value = data.tlf1 === null ? data.tlf1 : data.tlf1.trim();
    txtCelOrg.current.value = data.tlf2 === null ? data.tlf2 : data.tlf2.trim();
    cmbCiudad.current.value = data.ciudad === null ? "" : data.ciudad.trim();
    cmbMunicipio.current.value =
      data.municipio === null ? "" : data.municipio.trim();
    cmbEstado.current.value = data.estado === null ? "" : data.estado.trim();
    cmbBaseDatos.current.value =
      data.idbasedatos === null ? "" : data.idbasedatos.trim();
    cmbStatus.current.value = data.statusorg === null ? "" : data.statusorg;
    txtCedula.current.value = data.responsable;

    setHabilitadoNU(true);
    txtNombreRespon.current.value = "";
    txtApellidoRespon.current.value = "";
    txtDireccionRespon.current.value = "";
    txtEmailRespon.current.value = "";
    txtTlfRespon.current.value = "";
    txtCelRespon.current.value = "";
    txtFechaNac.current.value = "";
    cmbNacionalidad.current.value = "V";
    cmbSexo.current.value = "M";
    if (dataper.data !== "") {
      setHabilitadoNU(false);
      setOperacionPer(0);
      txtNombreRespon.current.value = dataper.data.nombres;
      txtApellidoRespon.current.value = dataper.data.apellidos;
      txtDireccionRespon.current.value = dataper.data.direccion;
      txtEmailRespon.current.value = dataper.data.correoe;
      txtTlfRespon.current.value = dataper.data.tlf1;
      txtCelRespon.current.value = dataper.data.tlf2;
      txtFechaNac.current.value = moment(dataper.data.fnacimiento).format(
        "YYYY-MM-DD"
      );
      cmbNacionalidad.current.value = dataper.data.nacionalidad;
      cmbSexo.current.value = dataper.data.sexo;
      btnAcepta.current.focus();
    } else {
      setOperacionPer(1);
      setHabilitadoNU(true);
    }
  };

  useEffect(() => {
    seleccionarBasedeDatos();
    CatalogoEstado();
  }, []);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        setOperacion(props.operacion);
        if (props.operacion !== 1) {
          seleccionarOrganizacion(props.organizacion.idorganizacion);
        }
      }}
    >
      <Modal.Header className="azulGradiant header-modal">
        <div className="fw-bold text-light">
          <h3>
            {operacion === 1
              ? "Agregar Afiliado."
              : operacion === 2
                ? "Editar Afiliado."
                : operacion === 3
                  ? "Eliminar Afiliado."
                  : "Consultar Afiliado."}
          </h3>
        </div>
        <button
          className="bg-transparent"
          style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }}
          onClick={cancelar}
        >
          <i className="far fa-window-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div>
          <div>
            <ul className="nav nav-tabs mb-3" id="ex-with-icons" role="tablist">
              <li className="nav-item" role="presentation">
                <a
                  className={activeTab.tab1}
                  id="ex-with-icons-tab-1"
                  style={{ backgroundColor: "#25d366" }}
                  onClick={tabs(1)}
                  data-mdb-toggle={tabIndex.tab1}
                  href="#tab1"
                  role="tab"
                  aria-controls="tab1"
                  aria-selected={tabvalid.tab1}
                >
                  <i className="fas fa-chart-pie fa-fw me-2" />
                  Datos Gnr.
                </a>
              </li>
              <li className="nav-item" role="presentation">
                <a
                  className={activeTab.tab2}
                  id="ex-with-icons-tab-2"
                  style={{ backgroundColor: "#55acee" }}
                  onClick={tabs(2)}
                  data-mdb-toggle={tabIndex.tab2}
                  href="#tab2"
                  role="tab"
                  aria-controls="tab2"
                  aria-selected={tabvalid.tab2}
                >
                  <i className="fas fa-chart-line fa-fw me-2" />
                  Responsable
                </a>
              </li>
            </ul>
            <div className="tab-content" id="ex-with-icons-content">
              <div
                className={tabPanel.tab1}
                id="tab1"
                role="tabpanel"
                aria-labelledby="ex-with-icons-tab-1"
              >
                <div className="container-fluid row bg-light h-100 py-4 px-4 rounded mx-auto">
                  <div
                    className="input-group mb-3 input-group-sm col-sm-3"
                    style={{
                      visibility:
                        props.menu === "sistema" ? "visible" : "hidden",
                    }}
                  >
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Codigo:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      disabled
                      ref={txtIdOrg}
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>

                  <div
                    className="input-group mb-3 input-group-sm col-sm-3 px-1"
                    style={{
                      visibility:
                        props.menu === "sistema" ? "visible" : "hidden",
                    }}
                  >
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Cantidad Items Factura:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      disabled={operacion === 1 || operacion === 2 ? false : true}
                      ref={txtItemsfactu}
                      name="items"
                      onChange={onChange}
                      maxLength={2}
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                    />
                  </div>

                  <div className="col-md-4"></div>

                  <div className="input-group mb-3 input-group-sm col-sm-4">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Rif:
                    </label>
                    <select
                      disabled={operacion === 1 ? false : true}
                      ref={cmbRif}
                      className="col-2 form-control form-control-sm"
                      id="inputLetraRif"
                    >
                      <option value="J">J</option>
                      <option value="V">V</option>
                      <option value="G">G</option>
                      <option value="E">E</option>
                      <option value="P">P</option>
                    </select>
                    <input
                      type="text"
                      disabled={operacion === 1 ? false : true}
                      ref={txtRif}
                      maxLength={9}
                      className="form-control form-control-sm"
                      name="riforg"
                      placeholder="123456789"
                      id="inputRif"
                      onChange={onChange}
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>
                  <div className="input-group mb-3 input-group-sm col-sm-8">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Nombre:
                    </label>
                    <input
                      type="text"
                      className="form-control uppercase"
                      disabled={deshabilitado}
                      ref={txtNomOrg}
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputNombre"
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>
                  <div className="input-group mb-3 input-group-sm col-sm-12">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Dirección:
                    </label>
                    <input
                      type="text"
                      disabled={deshabilitado}
                      ref={txtDomicilio}
                      className="form-control uppercase"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputDomicilio"
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>

                  <div className="input-group mb-3 input-group-sm col-sm-4">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Estado:
                    </label>
                    <select
                      className="form-select"
                      aria-label="Default select example col-md-4"
                      name="idestado"
                      disabled={deshabilitado}
                      ref={cmbEstado}
                      onChange={onChange}
                      id="inputFechaReg"
                    >
                      <option value={""}>SELECCIONAR ESTADO</option>
                      {estado &&
                        estado.map((item, index) => (
                          <option key={index} value={item.idestado}>
                            {" "}
                            {item.nombre}{" "}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="input-group mb-3 input-group-sm col-sm-4">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Municipio:
                    </label>
                    <select
                      className="form-select"
                      aria-label="Default select example col-md-4"
                      name="idmunicipio"
                      disabled={deshabilitado}
                      ref={cmbMunicipio}
                      onChange={onChange}
                    >
                      <option value={""}>SELECCIONAR MUNICIPIO</option>
                      {municipio &&
                        municipio.map((item, index) => (
                          <option key={index} value={item.idmunicipio}>
                            {" "}
                            {item.nombre}{" "}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="input-group mb-3 input-group-sm col-sm-4">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Ciudad:
                    </label>
                    <select
                      className="form-select"
                      aria-label="Default select example col-md-4"
                      name="idciudad"
                      disabled={deshabilitado}
                      ref={cmbCiudad}
                      onChange={onChange}
                    >
                      <option value={""}>SELECCIONAR CIUDAD</option>
                      {ciudad &&
                        ciudad.map((item, index) => (
                          <option key={index} value={item.idciudad}>
                            {" "}
                            {item.nombre}{" "}
                          </option>
                        ))}
                    </select>
                  </div>

                  <div className="input-group mb-3 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      E-mail:
                    </label>
                    <input
                      type="text"
                      disabled={deshabilitado}
                      ref={txtEmailOrg}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputEmailOrg"
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>

                  <div className="input-group mb-3 input-group-sm col-sm-3">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Telefono:
                    </label>
                    <input
                      type="text"
                      disabled={deshabilitado}
                      maxLength={11}
                      ref={txtTlfOrg}
                      name="telefonoorg"
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputTlfOrg"
                      onChange={onChange}
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>

                  <div className="input-group mb-3 input-group-sm col-sm-3">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Celular:
                    </label>
                    <input
                      type="text"
                      disabled={deshabilitado}
                      maxLength={11}
                      ref={txtCelOrg}
                      name="celularorg"
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputCelOrg"
                      onChange={onChange}
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>
                  <div
                    className="input-group mb-3 input-group-sm col-sm-5"
                    style={{
                      visibility:
                        props.menu === "sistema" ? "visible" : "hidden",
                    }}
                  >
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Base de Datos:
                    </label>
                    <select
                      className="form-select"
                      aria-label="Default select example col-md-4"
                      name="conexion"
                      disabled={deshabilitado}
                      ref={cmbBaseDatos}
                      onChange={onChange}
                    >
                      <option value={""}>SELECCIONAR CONEXION</option>
                      {baseDatos &&
                        baseDatos.map((item, index) => (
                          <option key={index} value={item.idbasedatos}>
                            {" "}
                            {item.nombre.toUpperCase()}{" "}
                          </option>
                        ))}
                    </select>
                  </div>
                  <div
                    className="input-group mb-3 input-group-sm col-sm-5"
                    style={{
                      visibility:
                        props.menu === "sistema" ? "visible" : "hidden",
                    }}
                  >
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Estatus:{" "}
                    </label>
                    <select
                      className="form-select"
                      aria-label="Default select example col-md-4"
                      name="status"
                      disabled={deshabilitado}
                      ref={cmbStatus}
                      onChange={onChange}
                    >
                      <option value={""}>SELECCIONAR ESTATUS</option>
                      <option value={true}>ACTIVO</option>
                      <option value={false}>INACTIVO</option>
                    </select>
                  </div>

                  <div className="row col-md-12">
                    <div
                      className="row col-md-6 mx-auto d-flex justify-content-center py-2"
                      style={{ height: 150, width: 150 }}
                    >
                      <div className="col-md-12 mx-auto d-flex justify-content-center">
                        <img
                          src={pathImage.imagen}
                          className="rounded-circle shadow position-absolute"
                          style={{ height: 150, width: 150 }}
                          alt=""
                        />
                        <input
                          type="file"
                          disabled={deshabilitado}
                          style={{
                            opacity: 0,
                            height: 150,
                            width: 150,
                          }}
                          onChange={handleUpload}
                          name="imagen"
                          accept="image/jpeg, image/png"
                          className="btn rounded-circle"
                        />
                      </div>
                      <div className="col-md-12 mx-auto d-flex justify-content-center">
                        <h2>Logo</h2>
                      </div>
                    </div>
                    <div
                      className="row col-md-6 mx-auto d-flex justify-content-center py-2"
                      style={{ height: 150, width: 150 }}
                    >
                      <div className="col-md-12 mx-auto d-flex justify-content-center">
                        <img
                          src={pathTicket.ticket}
                          className="rounded-circle shadow position-absolute"
                          style={{ height: 150, width: 150 }}
                          alt=""
                        />
                        <input
                          type="file"
                          disabled={deshabilitado}
                          style={{
                            opacity: 0,
                            height: 150,
                            width: 150,
                          }}
                          onChange={handleUpload}
                          name="ticket"
                          accept="image/jpeg, image/png"
                          className="btn rounded-circle"
                        />
                      </div>
                      <div className="col-md-12 mx-auto d-flex justify-content-center">
                        <h2>Ticket</h2>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={tabPanel.tab2}
                id="tab2"
                role="tabpanel"
                aria-labelledby="ex-with-icons-tab-2"
              >
                <div className="container-fluid row bg-light h-100 py-4 px-2 rounded mx-auto">
                  <div className="input-group mb-3 input-group-sm col-sm-5">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Cedula:
                    </label>
                    <select
                      disabled={!habilitadoNU}
                      ref={cmbNacionalidad}
                      className="form-select col-md-3"
                      aria-label="Default select example "
                    >
                      <option key="0" value="V">
                        V
                      </option>
                      <option key="1" value="E">
                        E
                      </option>
                    </select>
                    <input
                      type="text"
                      disabled={deshabilitado}
                      ref={txtCedula}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      onKeyUp={validarPersona}
                      onBlur={validarPersona}
                    />
                  </div>
                  <div className="col-md-1"></div>

                  <div className="input-group mb-3 input-group-sm col-sm-2">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Sexo:
                    </label>
                    <select
                      disabled={!habilitadoNU}
                      ref={cmbSexo}
                      className="form-select"
                      aria-label="Default select example "
                    >
                      <option key="0" value="M">
                        M
                      </option>
                      <option key="1" value="F">
                        F
                      </option>
                    </select>
                  </div>
                  <div className="input-group mb-3 input-group-sm col-sm-4">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Fecha Nacimiento:
                    </label>
                    <input
                      type="date"
                      disabled={!habilitadoNU}
                      ref={txtFechaNac}
                      max={moment(fecha).format("YYYY-MM-DD")}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputFechaNac"
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>

                  <div className="input-group mb-3 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Nombres:
                    </label>
                    <input
                      type="text"
                      disabled={!habilitadoNU}
                      ref={txtNombreRespon}
                      className="form-control text-uppercase"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputNombreRespon"
                      name="inputNombreRespon"
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>

                  <div className="input-group mb-3 input-group-sm col-sm-6">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Apellidos:
                    </label>
                    <input
                      type="text"
                      disabled={!habilitadoNU}
                      ref={txtApellidoRespon}
                      className="form-control text-uppercase"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputApellidoRespon"
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>

                  <div className="input-group mb-3 input-group-sm col-sm-12">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Direccion:
                    </label>
                    <textarea
                      disabled={!habilitadoNU}
                      ref={txtDireccionRespon}
                      className="form-control text-uppercase"
                      id="textAreaExample"
                      rows="3"
                    ></textarea>
                  </div>

                  <div className="input-group mb-3 input-group-sm col-sm-4">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      E-mail:
                    </label>
                    <input
                      type="text"
                      disabled={!habilitadoNU}
                      ref={txtEmailRespon}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputEmailRespon"
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>

                  <div className="input-group mb-3 input-group-sm col-sm-4">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Telefono:
                    </label>
                    <input
                      type="text"
                      disabled={!habilitadoNU}
                      maxLength={11}
                      ref={txtTlfRespon}
                      onChange={validaSoloNumero}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputTlfRespon"
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>

                  <div className="input-group mb-3 input-group-sm col-sm-4">
                    <label
                      className="input-group-text"
                      id="inputGroup-sizing-sm"
                    >
                      Celular:
                    </label>
                    <input
                      type="text"
                      disabled={!habilitadoNU}
                      ref={txtCelRespon}
                      maxLength={11}
                      onChange={validaSoloNumero}
                      className="form-control"
                      aria-label="Sizing example input"
                      aria-describedby="inputGroup-sizing-sm"
                      id="inputCelRespon"
                      onKeyUp={handleInputChange}
                      onBlur={handleInputChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          type="button"
          ref={btnAcepta}
          onClick={onChangeValidar}
          disabled={operacion === 4 ? true : false}
          style={{
            margin: "1px",
            visibility: operacion === 4 ? "hidden" : "visible",
          }}
          className="col-sm-2 btn btn-success btn-sm rounded-pill"
        >
          <i className="far fa-check-circle"></i>Aceptar
        </button>
        <button
          type="button"
          ref={btnCancela}
          onClick={cancelar}
          style={{ margin: "1px" }}
          className="col-sm-2 btn btn-sm btn-danger rounded-pill"
        >
          <i className="fas fa-window-close"></i>Cancelar
        </button>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          mensaje.titulo === "Exito."
            ? cerrarModal()
            : setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" });
        }}
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />
      <Dimmer active={activate} inverted>
        <Loader inverted>cargando...</Loader>
      </Dimmer>
      <CatalogoPersonaAthos
        titulo={""}
        mensaje={""}
        show={mostrar3}
        onHideCancelaCatPer={handleCloseCatalogoPer}
        onHideAceptaCatPer={handleAceptaCatalogoPer}
      />
    </Modal>
  );
};



// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/modalActualizarAfiliados.js